import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { logger } from "@/lib/logger";
import { SectionHeader } from "@/components/SectionHeader";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatDateTime } from "@/lib/format";

export default function AuditPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let m = true;
    api
      .get("/audit-logs")
      .then((r) => { if (m) setRows(r.data); })
      .catch((e) => logger.error("Failed to load audit logs", e));
    return () => { m = false; };
  }, []);
  return (
    <div data-testid="audit-page">
      <SectionHeader title="Audit Logs" description="All user actions across the system." />
      <Card className="rounded-xl border border-border bg-card p-4 shadow-sm">
        <div className="overflow-x-auto rounded-md border border-border">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/40">
                <TableHead className="label-caps">When</TableHead>
                <TableHead className="label-caps">User</TableHead>
                <TableHead className="label-caps">Action</TableHead>
                <TableHead className="label-caps">Details</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} className="hover:bg-muted/40">
                  <TableCell className="text-xs text-muted-foreground tabular-nums">{formatDateTime(r.created_at)}</TableCell>
                  <TableCell className="text-sm">{r.user_email || r.user_id}</TableCell>
                  <TableCell className="text-sm font-medium">{r.action}</TableCell>
                  <TableCell className="max-w-md truncate text-xs font-mono text-muted-foreground">{JSON.stringify(r.details)}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={4} className="py-10 text-center text-sm text-muted-foreground">No logs yet.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
